import React, { FC, useEffect, useState } from 'react';
import {
  PageWrapper,
  useShowAlertPopup,
  ProductCategoryForm,
  ProductCategory,
  FileUploadFile,
  useShowConfirmationPopup,
} from '@dew21/ui';
import axios from 'axios';
import { useHistory, useParams } from 'react-router';

export const EditProductCategory: FC = (props) => {
  const { id } = useParams();
  const [productCategory, setProductCategory] = useState<ProductCategory | null>(null);
  const history = useHistory();
  const showNotificationBanner = useShowAlertPopup();
  const showConfirmationPopup = useShowConfirmationPopup();

  const fetchProduct = () => {
    return axios.get(`/api/product/category/${id}`);
  };

  useEffect(() => {
    fetchProduct().then((response) => {
      setProductCategory(response.data);
    }).catch((error) => {
      setProductCategory(null);
    });
  }, []);

  return <PageWrapper
    breadCrumb={[
      { title: 'Produkte', path: '/products' },
      { title: 'Bearbeiten', path: `/products/category/${id}` },
    ]}
    marginal={{
      items: [{
        text: 'Kategorie löschen',
        icon: 'trash',
        actionFn: () => {
          showConfirmationPopup({
            open: true,
            actionButtonLabel: 'Löschen',
            closeFn() {
              showConfirmationPopup(null);
            },
            actionFn() {
              axios.delete(`/api/product/category/${id}`).then((response) => {
                history.push('/products/');
                showConfirmationPopup(null);
                showNotificationBanner({
                  renderContent: () => {
                    return <>Die Kategorie wurde gelöscht.</>;
                  },
                });
              }).catch((e) => {
                showNotificationBanner({
                  error: true, renderContent: () => {
                    return <>Die Kategorie konnte nicht gelöscht werden.</>;
                  },
                });
                showConfirmationPopup(null);
              });
            },
            renderer() {
              return <>Wollen Sie die Kategorie wirklich löschen?</>;
            },
          });
        },
      }],
    }}>
    <ProductCategoryForm
      onCancel={() => {
        history.push('/products');
      }}
      category={productCategory}
      setProductCategory={(payload: { attachment: FileUploadFile, category: ProductCategory }) => {
        const data = {
          category: payload.category,
          attachment: payload.attachment ? payload.attachment : null,
        };
        axios.put(`/api/product/category/${id}`, data).then((response) => {
          setProductCategory(response.data);
          showNotificationBanner({ renderContent: () => <>Die Kategorie wurde gespeichert.</> });
          history.push('/products');
        }).catch((error) => {
          showNotificationBanner({
            error: true,
            renderContent: () => <>Die Kategorie konnte nicht gespeichert werden.</>,
          });
          console.log(error);
        });
      }}/>
  </PageWrapper>;
};
